import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { MY_ORDERS_PATH } from '@/shared/config';
import { buttonVariants } from '@/shared/ui';

/** 못 찾음 — 내 견적 상세의 못 찾음과 같은 모양. 없는 주문·남의 주문·잘못된 주소를 구분하지 않는다(존재를 드러내지 않는다). */
export const MyOrderNotFound = (): ReactElement => (
  <section className="flex flex-col items-center gap-6 border-y border-foreground/10 py-24 text-center">
    <div className="flex flex-col gap-3">
      <h1 className="text-2xl font-bold tracking-[-0.02em] sm:text-3xl">
        주문을 찾을 수 없습니다.
      </h1>
      <p className="text-sm text-muted-foreground">
        삭제됐거나 다른 계정의 주문, 혹은 잘못된 주소일 수 있습니다.
      </p>
    </div>
    <Link to={MY_ORDERS_PATH} className={buttonVariants({ variant: 'outline', size: 'lg' })}>
      내 주문 목록으로
    </Link>
  </section>
);
